export default "__VITE_ASSET__BjzpZ2mW__"